/**
 * Opens a WhatsApp chat with a pre-filled inquiry message about the given listing.
 *
 * @param {string} title - The listing title to reference in the message.
 */
export const openWhatsAppInquiry = title => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const text = `Hello Agnes, I am interested in ${title}, URL: ${url}`;
  const waUrl = `https://api.whatsapp.com/send/?phone=6591684503&text=${encodeURIComponent(
    text
  )}&type=phone_number&app_absent=0`;
  window.open(waUrl, '_blank', 'noopener,noreferrer');
};
